import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const removeTopPanelFromSelectedEntity = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) {
    return null;
  }

  const currentTop = coreApi.entities.findEntityInHierarchyWithOneOfProductTypes(selectedEntity, [
    ProductType.BESTA_TOP_PANEL,
    ProductType.BESTA_TOP_PANEL_TV_BENCH
  ]);

  if (!currentTop) {
    return null;
  }

  coreApi.entities.delete(currentTop);
};

export default removeTopPanelFromSelectedEntity;
